import store from '@/store'
const base = {
  inheritAttrs: false,
  methods: {
    strToLower: function(str) {
      return str.toLowerCase();
    },
    strToUpper: function(str) {
      return str.toUpperCase();
    },
    /// D A T A   F E T C H   S T A R T
    authData: function (tc, pass) {
      return store.dispatch('auth/login', { tc: tc, pass: pass}).then(
        () => {
          return true
        },
        error => { // eslint-disable-line
          return false
        }
      );
    },
    incompleteCompletionData: async function (student_id) {
      await store.dispatch('exam/incompleteCompletion', student_id).then(
        () => {
          return true;
        },
        error => {
          if (error.response !== undefined && error.response.data !== undefined && typeof error.response.data.message !== undefined) {
            console.log(error.response.data.message)
          }
          return false
        }
      );
    },
    homeWorkData: async function (student_id, status = 'aktif') {
      await store.dispatch('exam/homeWork', { student_id: student_id, status: status}).then(
        () => {
          return true;
        },
        error => {
          if (error.response !== undefined && error.response.data !== undefined && typeof error.response.data.message !== undefined) {
            console.log(error.response.data.message)
          }
          return false
        }
      );
    },
    /// D A T A   F E T C H   E N D
    time: function (d = null) {
      let date = '';
      if (d == null) date = new Date()
      else date = new Date(moment(d, "YYYY-MM-DD HH:mm:ss").toDate()) // eslint-disable-line
      return Math.floor(date.getTime() / 1000)
    },
    timeCheck(exam_start_time, exam_finish_time, total_second, started_time = null) {
      let ret = 0
      exam_start_time = this.time(exam_start_time)
      exam_finish_time = this.time(exam_finish_time)
      // console.log(exam_start_time, exam_finish_time)
      total_second = Number(total_second)
      started_time = Number(started_time)
      if (started_time == null || started_time == 0) { // we have time
        ret = total_second
        
        if (this.time() > this.time(exam_finish_time)) {
          ret = 0
        }
      } else {
        let now = this.time();
        if (now < exam_finish_time) {
          let target_time = started_time + total_second;
          if (target_time > exam_finish_time) {
            target_time = exam_finish_time
          }
          ret = target_time - now
          //console.log(target_time, now)
        }
      }
      return ret < 0 ? 0 : ret
    },
    answerHash(answer) {
      let ret = null;
      if (answer == 'db7bc106d8da317dc09f7c624f611ab8') {
        ret = 'A'
      } else if (answer == '26dc21c9db50c4a738994adebdb1228e') {
        ret = 'B'
      } else if (answer == '82c87f2401bd3b08cc5aa7637ed9dedd') {
        ret = 'C'
      } else if (answer == 'bd754e16151a5dec6fc2849150dc83f5') {
        ret = 'D'
      } else if (answer == '5e332aea1e0204ac20bcec799ad33c9a') {
        ret = 'E'
      }
      return ret
    },
    dateConverter(date, time = false, second = false) {
      let new_date = null
      if (typeof date == 'string') {
        new_date = new Date(moment(date, "YYYY-MM-DD HH:mm:ss").toDate()) // eslint-disable-line
      } else {
        new_date = new Date(moment(date).toDate()) // eslint-disable-line
      }
      
      let ret = new_date.toLocaleDateString("tr-TR", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
      if (time) {
        if (second) {
          ret = ret + ' - ' + new_date.toLocaleTimeString("tr-TR", { hour: '2-digit', minute: '2-digit', second: '2-digit' })
        } else {
          ret = ret + ' - ' + new_date.toLocaleTimeString("tr-TR", { hour: '2-digit', minute: '2-digit' })
        }
      } else if (time == null) {
        ret = new_date.toLocaleDateString("tr-TR", { weekday: 'long', month: 'long', day: 'numeric' }) + ' - ' + new_date.toLocaleTimeString("tr-TR", { hour: '2-digit', minute: '2-digit' })
      }
      return ret
    },
    secondToTime(time) {
      let minutes = Math.floor(time / 60)
      let seconds = ((time % 60) / 1).toFixed(0)
      if (seconds == 60) {
        seconds = 59
      }
      return {
        m: Number(minutes),
        s: Number(seconds)
      }
    },
    authClean: function() {
      localStorage.clear()
      store.dispatch('auth/logout');
      // localStorage.removeItem('token')
      this.$router.push({ name: 'Login', query: { cikis: '🐾' } })
    },
    deviceTimeNConnectionCheck: function () {
      let second = 20
      let sysAlert = null
      let sysConAlert = null
      setInterval(() => {

        if (! navigator.onLine) {

          if (sysConAlert == null) {
            sysConAlert = $.confirm({ // eslint-disable-line
              title: 'Bağlantı Sorunu',
              content: 'Evdeki Öğretmen uygulamasını kullanmaya devam edebilmeniz için cihazınızın internet bağlantısının olması gerekir.',
              type: 'red',
              typeAnimated: true,
              backgroundDismissAnimation: 'glow',
              buttons: {
                test: {
                  isHidden: true,
                  isDisabled: true,
                },
              }
            })
          }

        } else {

          if (sysConAlert != null) {
            sysConAlert.close()
            sysConAlert = null
          }
          
          second = second + 1
          if (second > 20) {
            fetch('https://worldtimeapi.org/api/timezone/Europe/Istanbul')
              .then((response) => {
                return response.json();
              })
              .then( (data) => {

                if (sysAlert != null) {
                  sysAlert.close()
                  sysAlert = null
                }
                
                let device_time = this.time();
                if (data.unixtime != undefined) {
                  if (data.unixtime < (device_time - 60) || data.unixtime > (device_time + 60) && sysAlert == null) {
                    sysAlert = $.confirm({ // eslint-disable-line
                      title: 'Cihaz zaman ayarınız yanlış!',
                      content: 'Evdeki Öğretmen projesini kullanmaya devam etmeniz için cihaz zaman ayarlarınızı doğru bir şekilde yapmalısınız. Aksi takdirde sistemi kullanımınıza izin verilmez. <br><small class="text-danger"><strong>Sizin Saat Ayarınız</strong>: ' + this.dateConverter((device_time * 1000), true, true) + ' </small> <br><small class="text-success"><strong>Doğru Ayar: </strong>' + this.dateConverter((data.unixtime * 1000), true, true) + '</small>',
                      type: 'red',
                      typeAnimated: true,
                      backgroundDismissAnimation: 'glow',
                      buttons: {
                        test: {
                          isHidden: true,
                          isDisabled: true,
                        },
                      }
                    })
                  }
                }
            });
            second = 0
          }
        }
      }, 1000);
    }, 
    routeBefore: function (to, from, next) { // eslint-disable-line

      let direct = null
      if (store.state.auth.student_id == null) { // auth check
        direct = 'Login'
      } else {
        if (store.state.auth.student_id == null) {
          if (localStorage.getItem('auth') == null) {
            direct = 'Login'
          } else {
            let actionPromise = setInterval(() => {
              if (store.state.auth.student_id != null) {
                clearInterval(actionPromise);
                // M O D U L E    C O N T R O L
                if ((to.name === 'HomeWork' || to.name === 'HomeWorkDetail' || to.name === 'HomeWorkPrint') && !store.state.app.home_work) {
                  direct = 'Home'
                }

              } else {
                clearInterval(actionPromise);
                if (this.$store.state.auth.error == null) {
                  this.$store.state.auth.error = 'Sunucudan gelen sonuçta bir sorun vardı. Daha sonra tekrar deneyin.'
                }
                direct = 'Login'
              }

            }, 1000);
          }
        } else {
          // M O D U L E    C O N T R O L
          if ((to.name === 'HomeWork' || to.name === 'HomeWorkDetail' || to.name === 'HomeWorkPrint') && !store.state.app.home_work) {
            direct = 'Home'
          }
        }
      }
      return direct
    }
  },
  computed: {
    getYear: function() {
      let year = new Date();
      return year.getFullYear();
    },
    appName: function() {
      return this.$store.state.app.name;
    },
    appVersion: function() {
      return this.$store.state.app.version;
    },
  }
}
export default base;